import { Toaster } from "sonner";
import { useApp } from "../context/AppContext";

export default function BrandToaster() {
  const { lang, theme } = useApp();
  return (
    <Toaster
      position={lang === "ar" ? "top-right" : "top-left"}
      dir={lang === "ar" ? "rtl" : "ltr"}
      theme={theme}
      closeButton
      toastOptions={{ className: "lux-toast", duration: 3800 }}
    />
  );
}
